module.exports = __webpack_public_path__ + "static/media/logo.af37e8ae.png";